// Languages whose sentences run together without a space after the full stop (。).
const NO_SPACE_LANGUAGES = ['ja', 'zh'];

/**
 * Returns the separator to place between two translated sentences rendered side by side.
 *
 * @param {String} language - i18n.language value, e.g. 'en', 'zh_Hans', 'ja'
 * @returns An empty string for Chinese and Japanese, a single space otherwise
 */
const sentenceSeparator = (language) => {
  const baseLanguage = (language || '').split(/[-_]/)[0];
  return NO_SPACE_LANGUAGES.includes(baseLanguage) ? '' : ' ';
};

export default sentenceSeparator;
